import React, { useContext, useState } from 'react';
import Modal from '../modal/Modal';
import { useTranslation } from 'react-i18next';
import { ClosureSvg } from '../../icons';
import { AUTH_EXIT, PAYMENT_EXIT, SUPPORT_EXIT } from '../../common/errorCodes';
import ManualController from '../../hoc/ManualController';
import { IHeaderClosureProps } from '../../interfaces';
import { useNavigate } from 'react-router-dom';
import { MainContext } from '../../context/main.context';
import { GAME_IFRAME_ID } from '../../common/constants';
import { getIframeSrcOrigin } from '../../common/tools';

const SUPPORT_ORIGINS: string[] = [ 'ticketList', 'firstTicketCreate', 'ticketCreate', 'ticketItem' ];


export default function Closure({ origin, source }: IHeaderClosureProps) {
    const { t } = useTranslation();
    const [ showModal, setShowModal ] = useState<boolean>(false);
    const [ isPaymentsOrigin ] = useState<boolean>(Boolean(origin === 'payments'));
    const { manualRedirect } = ManualController();
    const navigate = useNavigate();
    const { modalContent, setModalContent } = useContext(MainContext);
    const [ isSupportOrigin ] = useState<Boolean>(SUPPORT_ORIGINS.includes(origin))

    const _returnToGame = (): void => {
        if (isSupportOrigin) {
            manualRedirect({}, 'support', true, SUPPORT_EXIT);
            return;
        }

        if (!isPaymentsOrigin) {
            manualRedirect({}, 'auth', true, AUTH_EXIT);
            return;
        }

        manualRedirect({}, 'payment', true, PAYMENT_EXIT);
    }

    const _onSubmit = (key: boolean): void => {
        if (key) {
            if (!isPaymentsOrigin) {
                setShowModal(false);
                return;
            }

            _returnToGame();
            return;
        }

        if (!isPaymentsOrigin) {
            _returnToGame();
            return;
        }

        setShowModal(false);
    }

    const _renderClosureModal = () => {
        return (
            <div className="closure-modal">
                <div className="closure-modal-title">
                    { !isPaymentsOrigin ? t('returnToGame') : t('payment.cancellation') }
                </div>
                <div className="closure-modal-buttons">
                    <button className="closure-modal-button" onClick={() => _onSubmit(true)}>
                        { !isPaymentsOrigin ? t('no') : t('yes') }
                    </button>
                    <button className="closure-modal-button closure-modal-button-color" onClick={() => _onSubmit(false)}>
                        { !isPaymentsOrigin ? t('yes') : t('no') }
                    </button>
                </div>
            </div>
        );
    }

    const _onClosureClick = () => {
        if (origin === 'transactions') {
            if (modalContent) {
                setModalContent(null);
                return;
            }

            navigate('/');
            return;
        }

        if (origin === 'transactionHelper') {
            if (modalContent) {
                setModalContent(null);
                return;
            }

            navigate('/');
            return;
        }

        if (modalContent) {
            if (source === 'web') {
                let type: string | null = null;
                let errorCode: number | null = null;

                if (origin === 'payments') {
                    type = 'PLAYHUB_TO_IFRAME_PAYMENT_RESULT';
                    errorCode = PAYMENT_EXIT;
                }

                if (origin === 'auth') {
                    type = 'PLAYHUB_TO_IFRAME_USER_AUTH';
                    errorCode = AUTH_EXIT;
                }

                if (type && errorCode) {
                    const iframe = document.getElementById(GAME_IFRAME_ID) as HTMLIFrameElement | null;

                    if (iframe?.contentWindow) {
                        const data = {};

                        const text: string = JSON.stringify({
                            data,
                            type: origin,
                            isError: true,
                            errorCode,
                        });

                        iframe.contentWindow.postMessage({ type, text }, getIframeSrcOrigin());
                    }
                }
            }

            setModalContent(null);
            return;
        }

        setShowModal(true);
    }

    return (
        <div className="closure-container" onClick={_onClosureClick}>
            <ClosureSvg/>
            {
                showModal ?
                    <Modal open onClose={() => setShowModal(false)} hideCloseButton>
                        {_renderClosureModal()}
                    </Modal>
                : null
            }
        </div>
    );
}